import { selectWarehouse } from '../Warehouses/warehousesSlice'
import useRentalStatus from './hooks/useRentalStatus'
import RentalStatusOption from './RentalStatusOption'
import useTranslation from 'hooks/useTranslation'
import { useParams } from 'react-router-dom'
import { useReduxSelector } from 'store'
import React from 'react'

interface MagStatusProps {
  isDesktop?: boolean
}

const type = process.env.REACT_APP_TYPE

const MagStatus: React.FC<MagStatusProps> = ({ isDesktop = false }) => {
  const { id } = useParams<warehouse.PageParams>()
  const { doorState, alarmState, hasOnlineAccess, hasAlarmZone, rentableType, typeName } = useReduxSelector(state => selectWarehouse(state, id))
  const rentalStatus = useRentalStatus(id)
  const isDoorUnlocked = doorState?.lock === 'unlocked'
  const isDoorOpen = doorState?.door === 'opened'

  const { t } = useTranslation('warehouse')

  return (
    <div className='menu__status'>
      {!isDesktop && <div className='line' />}
      <div className='status__options'>
        {(type === 'ldz01' && rentableType === 'warehouse')
          ? <div className={`status__option${isDoorUnlocked ? ' --important' : ''}`}>
            <i className={`icon icon--padlock-${isDoorOpen || isDoorUnlocked ? 'open' : 'closed'}`} />
            <span>{t(isDoorOpen ? 'doorsOpen' : isDoorUnlocked ? 'latchOpen' : 'doorsClosed')}</span>
          </div>
          : rentalStatus
            ? <RentalStatusOption status={rentalStatus} />
            : hasOnlineAccess
              ? <>
                <div className={`status__option${isDoorUnlocked ? ' --important' : ''}`}>
                  <i className={`icon icon--padlock-${isDoorOpen || isDoorUnlocked ? 'open' : 'closed'}`} />
                  <span>{t(isDoorOpen ? 'doorsOpen' : isDoorUnlocked ? 'latchOpen' : 'doorsClosed')}</span>
                </div>

                {hasAlarmZone && (alarmState?.alarmed === 'yes' || alarmState?.fire_alarmed === 'yes') && <div className='status__option --warning'>
                  <i className='icon icon--warning2' />
                  {alarmState?.alarmed === 'yes' && <span>{t('alarmTriggered')}{alarmState?.fire_alarmed === 'yes' ? ', ' : ''}</span>}
                  {alarmState?.fire_alarmed === 'yes' && <span>{t('fire')}</span>}
                </div>}
              </>
              : <div className='status__option'>
                {rentableType !== 'warehouse'
                  ? <span>{typeName}</span>
                  : <span>{t(type === 'chr01' ? 'keyLockedStorageUnit' : 'padlockedStorageUnit')}</span>}
              </div>}
      </div>
    </div>
  )
}

export default MagStatus